export default {"src":"https://marketplace-web-assets.vinted.com/_next/static/media/linkedin.504098f6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};